/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { type Theme, css } from '@emotion/react'
import { BREAKPOINT_580, BREAKPOINT_870, BREAKPOINT_1440, Z_INDEX_GROUP_1 } from '@zcode-ui/themes'

export const container = ({ colors }: Theme) => css`
  display: flex;

  min-height: 230px;
  max-height: 280px;

  background-color: ${colors?.backgroundLightest};
  border: 1px solid ${colors?.background};
  border-radius: 12px;
  cursor: pointer;
`

export const longTermGridContainer = css`
  margin: 0 auto;
  min-width: initial;
  flex-direction: column;
  max-height: 408px;
  height: 408px;

  @media (min-width: ${BREAKPOINT_870}) and (max-width: 1439px) {
    max-height: 372px;
    height: 372px;
  }

  @media (max-width: ${BREAKPOINT_580}) {
    border: 0;
    border-radius: 0;
    width: 100%;
  }
`

export const newListingCardPlaceholder = css`
  @media (min-width: 768px) {
    max-height: 456px;
    height: 456px;
  }

  @media (max-width: 767px) {
    max-height: 436px;
    height: 436px;
  }
`

export const gridContainer = css`
  margin: 0 auto;
  min-width: initial;
  flex-direction: column;
  max-height: 390px;
  height: 360px;

  @media (min-width: ${BREAKPOINT_1440}) {
    height: 390px;
  }

  @media (max-width: 1439px) {
    height: 350px;
  }

  @media (max-width: ${BREAKPOINT_870}) {
    height: 390px;
  }

  @media (max-width: ${BREAKPOINT_580}) {
    border: 0;
    border-radius: 0;
    height: 356px;
  }
`

export const imageSection = css`
  position: relative;

  flex: 1 1;
  width: 100%;
  max-width: 259px;
  height: inherit;
  max-height: 280px;
  overflow: hidden;

  img {
    width: 100%;
    cursor: pointer;
    object-fit: cover;
  }
`

export const gridImageSection = css`
  max-width: initial;
  flex: initial;

  height: 200px;
  min-height: 200px;

  border-top-right-radius: 11px;
  border-top-left-radius: 11px;

  @media (max-width: ${BREAKPOINT_1440}) {
    height: 164px;
    min-height: 164px;
  }

  @media (max-width: 870px) {
    height: 200px;
    min-height: 200px;
  }
`

export const hideSection = css`
  display: none;
`

export const contentSection = css`
  flex: 1;

  width: 419px;
  max-height: 280px;
`

export const gridContentSection = css`
  width: 100%;
  max-height: 100%;
`

export const badges = css`
  position: absolute;
  top: 10px;
  left: 15px;

  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 4px;
`

export const infoFavorite = css`
  position: absolute;
  top: 12px;
  right: 16px;

  display: flex;
  gap: 8px;
`

export const noPicImage = css`
  object-fit: cover;
`
